export type WsExceptionMessage = {
	code?: string;
	status?: string;
	message: string;
}

export type ServerErrorMessage = {
	errorMessage: string;
};

export type SelectorWSMessage = {
	key: string;
	value: string | number | null;
};

export type ToolCallWSMessage = {
	toolName: string;
	arguments: object;
	output: string;
};

export type ToolCallSuccessWSMessage = {
	request: {
		toolName: string;
		toolArguments: string;
		productUrl?: string;
		method?: string | null;
	};
	toolOutput: string;
};

export enum ChatMessageType {
	ServerError,
	UserError,
	NewSelector,
	AIMessage,
	ToolCall,
	UserMessage,
}

export type ChatMessage =
	| {
			t: ChatMessageType.ServerError;
			msg: string;
	  }
	| {
			t: ChatMessageType.UserError;
			msg: string;
	  }
	| {
			t: ChatMessageType.NewSelector;
			msg: SelectorWSMessage;
	  }
	| {
			t: ChatMessageType.AIMessage;
			msg: string;
	  }
	| {
			t: ChatMessageType.ToolCall;
			toolName: string;
			arguments: object;
			output: string;
	  }
	| {
			t: ChatMessageType.UserMessage;
			msg: string;
	  };

export enum ConversationState {
	NotStarted,
	Ongoing,
	WaitingForUserInput,
	Finished,
	Other,
	Disconnected,
}

export enum AIResultType {
	Success,
	NoTestURL,
	NoHTML,
	NoProductInHTML
}

export enum NoProductErrorType {
	NotFound,
	Captcha,
	Other
}

export type AISuggestions =
	| {
			t: AIResultType.Success;
			outputConfig: any;
	  }
	| {
			t: AIResultType.NoTestURL;
	  }
	| {
			t: AIResultType.NoHTML;
	  }
	| {
			t: AIResultType.NoProductInHTML;
			error: NoProductErrorType;
			description: string;
	  };

export type StateChangeCallbackContent =
	| {
			newState:
				| ConversationState.NotStarted
				| ConversationState.Ongoing
				| ConversationState.WaitingForUserInput;
	  }
	| {
			newState: ConversationState.Finished;
			conversationResult: AISuggestions;
	  };

export type MessageCallbackContent = {
	aiResponse: any;
};

export type ToolcallCallbackContent = {
	aiResponse: any;
	toolName: string;
	arguments: object;
	output: string;
};

export type UserMessageCallbackContent = {
	message: string;
};
